import { walletAccountUsecaseProvider } from '../usecase/usecase.provider';

export const walletAccountModuleProvider = [...walletAccountUsecaseProvider];
